import { Schema } from 'effect';
import { DeliveryPointSchema } from './deliveryPoint';

export const OrderIdSchema = Schema.Number;
export type OrderId = Schema.Schema.Type<typeof OrderIdSchema>;

export const OrderSchema = Schema.transform(
  Schema.Struct({
    id: OrderIdSchema,
    creation_timestamp: Schema.String,
    delivery_point: Schema.encodedSchema(DeliveryPointSchema),
    is_first_to_delivery_point: Schema.Boolean,
    name: Schema.String,
    suggested_weight_kg: Schema.optional(Schema.NullOr(Schema.Number)),
    is_priority: Schema.optional(Schema.NullOr(Schema.Boolean))
  }),
  Schema.Struct({
    id: OrderIdSchema,
    creationTimestamp: Schema.String,
    deliveryPoint: DeliveryPointSchema,
    isFirstToDeliveryPoint: Schema.Boolean,
    name: Schema.String,
    suggestedWeightKg: Schema.optional(Schema.NullOr(Schema.Number)),
    isPriority: Schema.optional(Schema.NullOr(Schema.Boolean))
  }),
  {
    strict: true,
    decode: (api) => ({
      id: api.id,
      creationTimestamp: api.creation_timestamp,
      deliveryPoint: api.delivery_point,
      isFirstToDeliveryPoint: api.is_first_to_delivery_point,
      name: api.name,
      suggestedWeightKg: api.suggested_weight_kg,
      isPriority: api.is_priority
    }),
    encode: (client) => ({
      id: client.id,
      creation_timestamp: client.creationTimestamp,
      delivery_point: client.deliveryPoint,
      is_first_to_delivery_point: client.isFirstToDeliveryPoint,
      name: client.name,
      suggested_weight_kg: client.suggestedWeightKg,
      is_priority: client.isPriority
    })
  }
);
export type Order = Schema.Schema.Type<typeof OrderSchema>;
